// Router mínimo basado en hash (sin react-router: este entorno no puede
// instalar paquetes nuevos). Suficiente para el número reducido de pantallas
// de Fase 1; si el proyecto migra a un entorno con npm normal, se puede
// reemplazar por react-router-dom sin tocar las páginas (solo este archivo
// y los <Link>).
import React, { createContext, useContext, useEffect, useState } from "react";

type RouterState = { path: string; navigate: (to: string) => void };
const RouterContext = createContext<RouterState | null>(null);

function currentHashPath() {
  const h = window.location.hash.replace(/^#/, "");
  return h || "/";
}

export function RouterProvider({ children }: { children: React.ReactNode }) {
  const [path, setPath] = useState(currentHashPath());

  useEffect(() => {
    const onHashChange = () => setPath(currentHashPath());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const navigate = (to: string) => {
    window.location.hash = to;
  };

  return <RouterContext.Provider value={{ path, navigate }}>{children}</RouterContext.Provider>;
}

export function useRouter() {
  const ctx = useContext(RouterContext);
  if (!ctx) throw new Error("useRouter debe usarse dentro de <RouterProvider>");
  return ctx;
}

export function Link({ to, className, children, onClick }: { to: string; className?: string; children: React.ReactNode; onClick?: () => void }) {
  const { navigate } = useRouter();
  return (
    <a
      href={`#${to}`}
      className={className}
      onClick={(e) => { e.preventDefault(); onClick?.(); navigate(to); }}
    >
      {children}
    </a>
  );
}
